import * as helpers from 'src/api/helpers'
import * as compares from 'src/api/compares'
import {
  GET_CROSS_CHECKS_HELPERS,
  GET_COMPARE_HELPERS,
  GET_COMPARE_FEE_HELPERS
} from 'src/store/mutation-types'

const getCrossChecksHeppers = ({commit, dispatch}) => {
  dispatch('toggleLoadding', true, {root: true})
  helpers.getCrossChecksHeppers().then(response => {
    if (response) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_CROSS_CHECKS_HELPERS, response)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_CROSS_CHECKS_HELPERS, [])
    }
  })
}
const getCompareHeppers = ({commit, dispatch}) => {
  dispatch('toggleLoadding', true, {root: true})
  compares.getCompareHeppers().then(response => {
    if (response) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_COMPARE_HELPERS, response)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_COMPARE_HELPERS, [])
    }
  })
}
const getCompareFeeHeppers = ({commit, dispatch}) => {
  dispatch('toggleLoadding', true, {root: true})
  compares.getCompareFeeHeppers().then(response => {
    if (response) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_COMPARE_FEE_HELPERS, response)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_COMPARE_FEE_HELPERS, [])
    }
  })
}

export default {
  getCrossChecksHeppers,
  getCompareHeppers,
  getCompareFeeHeppers
}



// WEBPACK FOOTER //
// ./src/components/compare/store/actions.js